export type CartLineIdentity = {
  productId: string
  variantId?: string | null
}

export function cartLinesEqual(a: CartLineIdentity, b: CartLineIdentity): boolean {
  return (
    a.productId === b.productId &&
    (a.variantId ?? '') === (b.variantId ?? '')
  )
}
